import { useState } from "react";
//import { ChevronLeft, ChevronRight } from "lucide-react";
import { projectsData } from "../../../../Components/Data/ProjectsData";

export default function ProjectCarousel({ items = projectsData }){
     const [index, setIndex] = useState(0);
 
  const goPrev = () => setIndex((i) => (i === 0 ? items.length - 1 : i - 1));
  const goNext = () => setIndex((i) => (i === items.length - 1 ? 0 : i + 1));
 
  const project = items[index];
 
  return (
    <div style={{ maxWidth: "90%", width: 1100, margin: "0 auto", fontFamily: "sans-serif" }}>
      {/* Slide */}
      <div
        style={{
          position: "relative",
          borderRadius: 12,
          overflow: "hidden",
          border: "1px solid #e5e5e5",
        }}
      >
        <img
          src={project.image}
          alt={project.title}
          style={{ width: "100%", height: 450, objectFit: "cover", display: "block" }}
        />
 
        {/* Prev arrow */}
        <button
          onClick={goPrev}
          aria-label="Previous project"
          style={arrowStyle("left")}
          className="arrow-styles"
        >
          ←
        </button>
 
        {/* Next arrow */}
        <button
          onClick={goNext}
          aria-label="Next project"
          style={arrowStyle("right")}
          className="arrow-styles"
        >
         →
        </button>
      </div>
 
      {/* Info below the slide */}
      <div className="featured-projects-info" style={{ padding: "20px 4px" }}>
        <h3 style={{ margin: "0 0 4px", fontSize: 20 }}>{project.title}</h3>
        <p style={{ margin: "0 0 8px", color: "#666", fontSize: 14 }}>
          {project.client}
        </p>
        <p style={{ margin: "0 0 12px", fontSize: 15, lineHeight: 1.5 }}>
          {project.description}
        </p>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
          {project.tags.map((tag) => (
            <span
              key={tag}
              style={{
                fontSize: 12,
                padding: "4px 10px",
                borderRadius: 999,
                background: "#f2f2f2",
                color: "#333",
              }}
            >
              {tag}
            </span>
          ))}
        </div>
        <a
          href={project.link}
          target="_blank"
          rel="noreferrer"
          className="project-view-link"
        >
          View project →
        </a>
      </div>
 
      {/* Counter + dots */}
      <div
        className="featured-projects-dots"
      >
        <div style={{ display: "flex", gap: 6 }}>
          {items.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              aria-label={`Go to slide ${i + 1}`}
              className="featured-projects-button"
              style={{
                background: i === index ? "#1a1a1a" : "#d4d4d4",
              }}
            />
          ))}
        </div>
        <span style={{ fontSize: 13, color: "#888" }}>
          {index + 1} / {items.length}
        </span>
      </div>
    </div>
  );
}

function arrowStyle(side) {
  return {
    [side]: 12,
  };
}